import React from 'react';
import AuthLayout from '../Auth/AuthLayout';
import AuthMobileHero from '../Auth/AuthMobileHero';
import '../Auth/style.css';

/**
 * Matches login / register: `page-container`, global auth CSS, `AuthMobileHero`.
 *
 * @param {{ children: React.ReactNode }} props
 */
export default function HcpSignupPageFrame({ children }) {
  return (
    <div className="page-container">
      <AuthLayout>
        <AuthMobileHero />
        {children}
      </AuthLayout>
    </div>
  );
}
